import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';

import { API_URL, enrichedFetch } from '../../services/api';
import { Conversation } from '../../Types/conversation';
import { Folder } from '../../Types/folder';
import { Prompt } from '../../Types/prompt';
import { AppDispatch } from '../store';

export const updateRelation = createAsyncThunk<
  void,
  {
    promptId?: Prompt['id'];
    conversationId?: Conversation['id'];
    folderId?: Folder['id'];
    pinned?: boolean;
    liked?: boolean;
  },
  { dispatch: AppDispatch }
>(
  'userSpecificRelations/updateRelation',
  async ({ promptId, conversationId, folderId, pinned, liked }, { rejectWithValue }) => {
    try {
      let url = `${API_URL}/user_specific_relations?`;

      if (promptId) {
        url += `promptId=${promptId}&`;
      }
      if (conversationId) {
        url += `conversationId=${conversationId}&`;
      }
      if (folderId) {
        url += `folderId=${folderId}&`;
      }

      if (pinned !== undefined) {
        url += `pinned=${pinned}&`;
      }
      if (liked !== undefined) {
        url += `liked=${liked}&`;
      }

      await enrichedFetch(url.substring(0, url.length - 1), { method: 'PUT' });
    } catch {
      enqueueSnackbar('Failed to update user prompt relation', { variant: 'error' });
      return rejectWithValue('Failed to update user prompt relation');
    }
  }
);
